import React from "react";
import { Link } from "react-router-dom";
import Countdown from "./Countdown";
import SmartImage from "./SmartImage";
import WatchlistButton from "./WatchlistButton";
import { useLanguage } from "../context/LanguageContext";

const fmt = (n, language) => new Intl.NumberFormat(language === "en" ? "en-IE" : "it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export default function AuctionCard({ auction, index = 0 }) {
  const { language, t } = useLanguage();
  return (
    <Link
      to={`/auction/${auction.id}`}
      data-testid={`auction-card-${auction.id}`}
      className="flex flex-col gap-3 group fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 300)}ms` }}
    >
      <div className="zoom-wrap aspect-[4/5] bg-stone-100 relative">
        <SmartImage src={auction.image_url} alt={auction.title} className="w-full h-full object-cover" fallbackText={auction.title} />
        <div className="absolute top-3 right-3">
          <WatchlistButton auctionId={auction.id} />
        </div>
        {auction.status === "sold" && (
          <div className="absolute top-3 left-3 bg-stone-900 text-stone-50 text-[10px] uppercase tracking-widest px-2 py-1">{t("Aggiudicato")}</div>
        )}
      </div>
      <div className="flex flex-col gap-1">
        <div className="overline text-stone-500">{auction.category?.replace(/-/g, " ")}</div>
        <h3 className="font-serif text-xl leading-snug line-clamp-2 group-hover:text-[#8C3A3A] transition-colors">
          {auction.title}
        </h3>
        <div className="mt-2 flex items-end justify-between border-t border-stone-200 pt-2">
          <div>
            <div className="text-[11px] uppercase tracking-wider text-stone-500">{t("Offerta attuale")}</div>
            <div className="font-mono text-lg font-medium">{fmt(auction.current_bid, language)}</div>
          </div>
          <div className="text-right">
            <div className="text-[11px] uppercase tracking-wider text-stone-500">{t("Termina")}</div>
            <Countdown endsAt={auction.ends_at} short className="text-sm" />
          </div>
        </div>
      </div>
    </Link>
  );
}
